import { render } from "./IconRibbon.vue?vue&type=template&id=44ba959c"
import script from "./IconRibbon.vue?vue&type=script&lang=js"
export * from "./IconRibbon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__